export const ONBOARDING_ENTRY_MAP_BY_NAME = {
  education: {
    id: 0,
    title: 'Education',
    text: 'Education'
  },
  skills: {
    id: 1,
    title: 'Skills',
    text: 'Skills'
  },
  experience: {
    id: 2,
    title: 'Experience',
    text: 'Experience'
  },
  licensesCerts: {
    id: 3,
    title: 'Licenses and Certs',
    text: 'Certs'
  },
  honorsAwards: {
    id: 4,
    title: 'Honors and Awards',
    text: 'Honors'
  }
};

export const SKILLS = [
  'Video Editing',
  'Videography',
  'Photography',
  'Writing',
  'Web Development',
  'Graphic Design',
  'Animation'
];


export const BRAND_ENTRY_MAP_BY_NAME = {
  pageOne: {
    id: 0,
    title: 'One',
    text: 'Consumer Analysis'
  },
  pageTwo: {
    id: 1,
    title: 'Two',
    text: 'Consumer Analysis'
  },
  pageThree: {
    id: 2,
    title: 'Three',
    text: 'Consumer Analysis'
  }
};